__turbopack_context__.v({
  "card": "UspsCustomerCare-module-scss-module__fc7tvW__card",
});
